import Cookies from 'js-cookie'
import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'
// console.log(getToken(), 888)
// const version = 'v104'
// create an axios instance
const service = axios.create({
  // baseURL: 'http://txcx.ailvpai.com:8080',
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  method: 'post',
  data: {},
  params: {},
  timeout: 5000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // console.log('公用 request')
    // do something before request is sent
    if (Cookies.set('language') === undefined) {
      config.headers['Accept-Language'] = 'zh-cn'
    }
    if (Cookies.set('language') === 'zh') {
      config.headers['Accept-Language'] = 'zh-cn'
    }
    if (Cookies.set('language') === 'en') {
      config.headers['Accept-Language'] = 'en-us'
    }
    // config.headers['Accept'] = `application/json:version=${version}`
    if (config.method === 'get') {
      config.params.token = getToken()
    }
    if (store.getters.token) {
      // console.log('store getters token')
      config.data.token = getToken()
    }
    return config
  },
  error => {
    // console.log('do something with request error')
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    // console.log('res is :')
    // console.log(res)

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 0) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })

      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      }
      // token失效
      if (res.code === 1000) {
        // store.dispatch('user/resetToken').then(() => {
        //   location.reload()
        // })
        store.dispatch('user/logout').then(() => { location.reload() })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    // 当响应异常时做一些处理
    if (error && error.response) {
      switch (error.response.status) {
        case 400: error.message = '请求错误 [400 Bad Request]'; break
        case 401: error.message = '未授权，请重新登录 [401 Unauthorized]'; break
        case 403: error.message = '拒绝访问 [403 Forbidden]'; break
        case 404: error.message = '请求出错 [404 Not Found]'; break
        case 408: error.message = '请求超时 [408 Request Timeout]'; break
        case 500: error.message = '服务器错误 [500 Internal Server Error]'; break
        case 501: error.message = '服务未实现 [501 Not Implemented]'; break
        case 502: error.message = '网络错误 [502 Bad Gateway]'; break
        case 503: error.message = '服务不可用 [503 Service Unavailable]'; break
        case 504: error.message = '网络超时 [504 Gateway Timeout]'; break
        case 505: error.message = 'HTTP版本不受支持 [505 HTTP Version Not Supported]'; break
        default: error.message = `连接出错(${error.response.status})!`
      }
    } else {
      error.message = '数据请求超时，请重试。[Data request timed out. Please try again.]'
    }
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
